<ngx-spinner [fullScreen]="false"
             bdColor="rgba(51,51,51,0.8)"
             color="#fff"
             size="medium"
             type="ball-clip-rotate-multiple">
</ngx-spinner>
<div fxLayout="row wrap">
  <div class="teranet-padding"
       fxFlex="100">
    <Teranet-PageTitle [PageTitle]="pageTitle"></Teranet-PageTitle>
    <div fxLayout="column"
         fxLayoutAlign="center stretch">
      <div fxFlex="50"
           fxLayout="row"
           fxLayoutAlign.lt-md="start"
           fxLayoutAlign="start start">
        <div fxFlex="30" fxLayout="start">
          <ul>
            <li><b>Account Number:</b> {{workQueueModel.productaccountnomortgage}}</li>
          </ul>
        </div>
        <div fxFlex="35" fxLayout="start">

          <div *ngIf="workQueueModel.queueHistoryDetails?.length > 0" fxFlex="70" fxLayout="column">
            <span><b>Queue History</b></span>
            <table>
              <tr *ngFor="let row of workQueueModel.queueHistoryDetails | slice:0:3; track row">
                <td colspan="4">{{ row.comments }}</td>
                <td colspan="1">{{ row.eventdatetime | date: 'MMM - yyyy' }}</td>
              </tr>
            </table>
            <div *ngIf="workQueueModel.queueHistoryDetails?.length > 3" fxLayout="row" fxLayoutAlign="end">
              <button (click)="openQueueHistoryDialog()"
                      aria-label="View More"
                      class="theme-button"
                      mat-raised-button>
                View More
              </button>
            </div>

          </div>

        </div>
        
      </div>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <b>Insurance Information</b>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxFlex="100"
             fxLayout="row wrap"
             fxLayoutAlign.lt-md="center center"
             fxLayoutAlign="space-around">

          <div fxFlex.lt-md="100"
               fxFlex="100"
               fxLayout="row wrap">
            <table fxFlex="50">
              <tr>
                <td width="15%"><b>Insurance Company:</b></td>
                <td width="10%">{{workQueueModel.insurecorporationcode}}</td>
                <td width="15%"><b>Notice Type:</b></td>
                <td width="15%">{{workQueueModel.noticetypepolicy}}</td>
              </tr>
              <tr>
                <td width="15%"><b>Policy Number:</b></td>
                <td width="10%">{{workQueueModel.policynumber}}</td>
                <td width="15%"><b>Dwelling Coverage:</b></td>
                <td width="15%">{{workQueueModel.dwellingcoverage}}</td>
              </tr>
              <tr>
                <td width="15%"><b>Insurance Effective Date:</b></td>
                <td width="10%">{{workQueueModel.policyeffectivedate | date: 'yyyy-MM-dd'}}</td>
                <td width="10%"></td>
                <td width="15%"></td>
              </tr>

            </table>

          </div>

          <div fxFlex.lt-md="100"
               fxFlex="100"
               fxLayout="row wrap">
            <table fxFlex="90">
              <tr>
                <th width="15%">Insured Last Name</th>
                <th width="15%">Insured First Name</th>
                <th width="20%">Property Street Address</th>
                <th width="20%">Property City</th>
                <th width="20%">Property Provience</th>
                <th width="10%">Property Postal Code</th>

              </tr>
              <tr>
                <td>{{ workQueueModel.insuredlastname }}</td>
                <td>{{ workQueueModel.insuredfirstname }}</td>
                <td>{{ workQueueModel.insureraddress }}</td>
                <td>{{ workQueueModel.insurercity }}</td>
                <td>{{ workQueueModel.insurerprovince }}</td>
                <td>{{ workQueueModel.insurerpostalcode }}</td>

              </tr>
            </table>

          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <b>RESL Information</b>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div fxFlex="100"
             fxLayout="row wrap"
             fxLayoutAlign.lt-md="left left"
             fxLayoutAlign="space-around">
          <div fxFlex.lt-md="100"
               fxFlex="100"
               fxLayout="row wrap">
            <table fxFlex="70">
              <tr>
                <td width="15%"><b>Mortgage Principal Balance:</b></td>
                <td width="10%">{{workQueueModel.mortgageprincipalbalance}}</td>
                <td width="10%"><b>Status:</b></td>
                <td width="15%"></td>
                <td width="20%"><b>Remaining Amortization (Months):</b></td>
                <td width="10%">{{ workQueueModel.remainingamortization }}</td>
              </tr>
              <tr>
                <td width="15%"><b>HELOC Principal Balance:</b></td>
                <td width="10%">{{workQueueModel.helocprincipalbalance}}</td>
                <td width="10%"><b>Appraised Value:</b></td>
                <td width="15%">{{workQueueModel.appraisedvalueprincipalbalance}}</td>
                <td width="20%"><b>Product Account Number - HELOC:</b></td>
                <td width="10%">{{workQueueModel.productaccountnomortgage}}</td>
              </tr>
              <tr>                
                <td width="15%"><b>RESL Advance Date:</b></td>
                <td width="10%">{{workQueueModel.resladvancedate | date: 'yyyy-MM-dd'}}</td>
                <td width="10%"><b>Total RESL Principal Balance:</b></td>
                <td width="15%">{{workQueueModel.totalreslprincipalbalance}}</td>
                <td width="20%"><b>RESL Maturity Date:</b></td>
                <td width="10%">{{workQueueModel.maturitydate}}</td>
              </tr>              
            </table>

          </div>


          <div fxFlex.lt-md="100"
               fxFlex="100"
               fxLayout="row wrap">
            <table fxFlex="90">
              <tr>
                <th width="15%">Borrowers Last Name</th>
                <th width="15%">Borrowers First Name</th>
                <th width="20%">Property Street Address</th>
                <th width="10%">Property City</th>
                <th width="20%">Property Province</th>
                <th width="15%">Property Postal Code</th>
              </tr>
              <tr>
                <td>{{ workQueueModel.borrowerslastname }}</td>
                <td>{{ workQueueModel.borrowersfirstname }}</td>
                <td>{{ workQueueModel.lenderaddress }}</td>
                <td>{{ workQueueModel.lendercity }}</td>
                <td>{{ workQueueModel.lenderprovince }}</td>
                <td>{{ workQueueModel.lenderpostalcode }}</td>

              </tr>
            </table>

          </div>

        </div>
      </mat-expansion-panel>
      
      <form (ngSubmit)="onSubmit()"
            [formGroup]="queueActionsFormGroup"
            novalidate>
        <div class="mat-elevation-z4">
          <mat-toolbar>
            {{queueName}}
          </mat-toolbar>

          <div class="teranet-padding">

            <mat-card fxFlex="100" fxLayout="column">
              <div fxFlex="100" fxLayout="row wrap" fxLayoutAlign="space-evenly">
                <div fxFlex.lt-md="90" fxFlex="65" fxLayout="colmn wrap">
                  <div class="teranet-padding" fxFlex="100" fxLayout="row wrap">
                    <table>
                      <tr>
                        <th class="md">Account Update</th>
                        <td class="show content">
                          <mat-radio-group required [(ngModel)]="workQueueUpdateModel.workqueueaccountupdateoptionid" formControlName="accountUpdateGroup" aria-label="Account Update:" (change)="checkSave()">
                            <mat-radio-button value="1" checked="{{workQueueUpdateModel.workqueueaccountupdateoptionid==1}}">Completed</mat-radio-button>
                            <mat-radio-button value="2" checked="{{workQueueUpdateModel.workqueueaccountupdateoptionid==2}}">Not Required</mat-radio-button>
                            <mat-radio-button value="3" checked="{{workQueueUpdateModel.workqueueaccountupdateoptionid==3}}">Assign</mat-radio-button>
                          </mat-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <th class="md">Insurance Follow-up</th>
                        <td class="show content">
                          <mat-radio-group required [(ngModel)]="workQueueUpdateModel.workqueueinsurancefollowupoptionid" formControlName="insuranceFollowupGroup" aria-label="Insurance Follow-up:" (change)="checkSave()">
                            <mat-radio-button value="1" checked="{{workQueueUpdateModel.workqueueinsurancefollowupoptionid==1}}">Completed</mat-radio-button>
                            <mat-radio-button value="2" checked="{{workQueueUpdateModel.workqueueinsurancefollowupoptionid==2}}">Not Required</mat-radio-button>
                            <mat-radio-button value="3" checked="{{workQueueUpdateModel.workqueueinsurancefollowupoptionid==3}}">Assign</mat-radio-button>
                          </mat-radio-group>
                        </td>
                      </tr>
                      <tr>
                        <th class="md">Customer Follow-up</th>
                        <td class="show content">
                          <mat-radio-group required [(ngModel)]="workQueueUpdateModel.workqueuecustomerfollowupoptionid" formControlName="customerFollowupGroup" aria-label="Customer Follow-up:" (change)="checkSave()">
                            <mat-radio-button value="1" checked="{{workQueueUpdateModel.workqueuecustomerfollowupoptionid==1}}">Completed</mat-radio-button>
                            <mat-radio-button value="2" checked="{{workQueueUpdateModel.workqueuecustomerfollowupoptionid==2}}">Not Required</mat-radio-button>
                            <mat-radio-button value="3" checked="{{workQueueUpdateModel.workqueuecustomerfollowupoptionid==3}}">Assign</mat-radio-button>
                          </mat-radio-group>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div fxFlex="100" fxLayout="row wrap">
                    <div class="form-group-flex-column" fxFlex="100">
                      <mat-label><b>Comments</b></mat-label>
                      <mat-form-field appearance="fill" class="mat-form-field-fl">
                        <textarea cdkAutosizeMinRows="2"
                                  cdkTextareaAutosize
                                  data-lpignore="true"
                                  formControlName="comments"
                                  title="Comments"                                
                                  matInput [(ngModel)]="workQueueUpdateModel.comments" (change)="checkSave()"></textarea>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="teranet-padding"
                     fxFlex.lt-md="90"
                     fxFlex="25"
                     fxLayout="column wrap">
                  <ul>
                    <li>
                      <b>Current Status</b>&nbsp;
                    </li>
                    <li>&nbsp;{{getWorkQueueStatus()}}</li>
                    <li><b>Update Status</b></li>
                    <mat-radio-group required [(ngModel)]="workQueueUpdateModel.workqueuestatusid" formControlName="updateStatus" aria-label="Update Status:" (change)="checkSave()" >
                      <li>
                        <mat-radio-button hidden="hidden" value="1" checked="{{workQueueUpdateModel.workqueuestatusid==1}}">Mark as New</mat-radio-button>
                      </li>

                      <li>
                        <mat-radio-button value="2" checked="{{workQueueUpdateModel.workqueuestatusid==2}}" disabled="{{workQueueModel.workqueuestatusid>=2}}">Mark as Under Review</mat-radio-button>
                      </li>
                      <li>
                        <mat-radio-button value="3" checked="{{workQueueUpdateModel.workqueuestatusid==3}}">Mark as Complete</mat-radio-button>
                      </li>
                    </mat-radio-group>
                  </ul>
                </div>
              </div>
            </mat-card>

          </div>
          <div fxLayout="row wrap" fxLayoutAlign="end">
            <button
                    (click)="setQueueActions(true)"
                    class="plain-button"
                    mat-raised-button
                    type="button">
              Cancel Queue Actions
            </button>
            <button (click)="UpdateQueue()"
                    [hidden]="false"
                    class="theme-button"
                    mat-raised-button
                    disabled="{{queueDisabled}}"
                    type="button" #saveBtn>
              Save Queue Action
            </button>

          </div>


        </div>
      </form>
      <div *ngIf="previousPage !== 'workqueue'"
           fxLayout="row wrap"
           fxLayoutAlign="end">
        <button (click)="goBack()"
                class="plain-button"
                mat-raised-button>
          Close
        </button>
      </div>
      <div *ngIf="previousPage === 'workqueue' "
           fxLayout="row wrap"
           fxLayoutAlign="space-between">
        <button (click)="goToWorkQueue()"
                class="plain-button"
                mat-raised-button>
          Return to Work Queue
        </button>
        <button (click)="goToNextQueue()"
                [disabled]="nextId==-1"
                class="theme-button"
                mat-raised-button>
          Next Account
        </button>
      </div>
    </div>
  </div>
</div>
